import type { ErrorPageConfig, ErrorPageCode } from '../types';
import { buildDevPortalUrl } from '../utils/environmentUtils';

const DEFAULT_ERROR: ErrorPageConfig = {
  buttonLink: '/',
  buttonText: 'Return to home',
  description:
    "We're having some trouble right now, but we're working on it. Try refreshing the page or come back later.",
  title: 'Something went wrong',
};

export const ERROR_PAGE_CONFIG: Record<ErrorPageCode, ErrorPageConfig> & {
  default: ErrorPageConfig;
} = {
  400: DEFAULT_ERROR,
  401: {
    buttonLink: buildDevPortalUrl('login'),
    buttonText: 'Sign in again',
    description: 'Your session has expired. Please sign in again to continue.',
    title: 'Your session expired',
  },
  404: {
    buttonLink: '/',
    buttonText: 'Return to home',
    description: "This page wasn't found. Please check your URL and try again.",
    title: 'Page not found',
  },
  500: DEFAULT_ERROR,
  default: DEFAULT_ERROR,
};
